module.exports = __webpack_public_path__ + "img/soundicon.9d24c72c.svg";